//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'QuickRadioItem',

	props: {
		value: String
	},

	data () {
		return {}
	},

	computed: {
		checked () {
			return this.$parent.value === this.value;
		}
	},

	methods: {
		handleClick() {
			let isSelected = this.$parent.currentValue === this.value;
			this.$emit('on-click',isSelected, this.value);
			this.$parent.currentValue =  isSelected ? '' : this.value;
		}	
	},

	created () {

	},
}



// WEBPACK FOOTER //
// ./src/components/quickRadio/quickRadioItem.vue